var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.context.classes.outer,
      attrs: {
        "data-classification": _vm.classification,
        "data-has-errors": _vm.hasErrors,
        "data-is-showing-errors": _vm.hasVisibleErrors,
        "data-has-value": _vm.hasValue,
        "data-type": _vm.type
      }
    },
    [
      _c(
        "div",
        { class: _vm.context.classes.wrapper },
        [
          _vm.context.labelPosition === "before"
            ? _vm._t(
                "label",
                function() {
                  return [
                    _vm.context.hasLabel
                      ? _c(
                          _vm.context.slotComponents.label,
                          _vm._b(
                            {
                              tag: "component",
                              attrs: { context: _vm.context }
                            },
                            "component",
                            _vm.context.slotProps.label,
                            false
                          )
                        )
                      : _vm._e()
                  ]
                },
                null,
                _vm.context
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.context.helpPosition === "before"
            ? _vm._t(
                "help",
                function() {
                  return [
                    _vm.context.help
                      ? _c(
                          _vm.context.slotComponents.help,
                          _vm._b(
                            {
                              tag: "component",
                              attrs: { context: _vm.context }
                            },
                            "component",
                            _vm.context.slotProps.help,
                            false
                          )
                        )
                      : _vm._e()
                  ]
                },
                null,
                _vm.context
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t(
            "element",
            function() {
              return [
                _c(
                  _vm.context.component,
                  _vm._g(
                    _vm._b(
                      { tag: "component", attrs: { context: _vm.context } },
                      "component",
                      _vm.context.slotProps.component,
                      false
                    ),
                    _vm.listeners
                  ),
                  [_vm._t("default", null, null, _vm.context)],
                  2
                )
              ]
            },
            null,
            _vm.context
          ),
          _vm._v(" "),
          _vm.context.labelPosition === "after"
            ? _vm._t(
                "label",
                function() {
                  return [
                    _vm.context.hasLabel
                      ? _c(
                          _vm.context.slotComponents.label,
                          _vm._b(
                            {
                              tag: "component",
                              attrs: { context: _vm.context }
                            },
                            "component",
                            _vm.context.slotProps.label,
                            false
                          )
                        )
                      : _vm._e()
                  ]
                },
                null,
                _vm.context
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.context.helpPosition === "after"
        ? _vm._t(
            "help",
            function() {
              return [
                _vm.context.help
                  ? _c(
                      _vm.context.slotComponents.help,
                      _vm._b(
                        { tag: "component", attrs: { context: _vm.context } },
                        "component",
                        _vm.context.slotProps.help,
                        false
                      )
                    )
                  : _vm._e()
              ]
            },
            null,
            _vm.context
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t(
        "errors",
        function() {
          return [
            !_vm.context.disableErrors
              ? _c(
                  _vm.context.slotComponents.errors,
                  _vm._b(
                    {
                      tag: "component",
                      attrs: {
                        type:
                          _vm.context.slotComponents.errors ===
                          "FormulateErrors"
                            ? "input"
                            : false,
                        context: _vm.context
                      }
                    },
                    "component",
                    _vm.context.slotProps.errors,
                    false
                  )
                )
              : _vm._e()
          ]
        },
        null,
        _vm.context
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }